import { TrackingEvent } from './tracking-event';
import Actions from '@/dictionary/tracking/actions';
import ISPAnalyticsEvent from '@/domain/dto/spanalytics-event.interface';
import ITrackingObject from '@/domain/dto/tracking-object.interface';

export class IncentiveEvent extends TrackingEvent {
	public constructor(protected label: string = Actions.INCENTIVE_IMPRESSION, protected additionalTags: string[] = []) {
		super(null, null, null);
	}

	/* base TrackingEvent's default label is `${provider}:${referrer}`, always null:null here since
		v2 has no provider/referrer concept for this event — use the actual label instead */
	protected get trackingEvent(): ITrackingObject {
		return {
			category: this.category,
			action: this.action,
			label: this.label,
		};
	}

	protected spanalyticsEvent(): ISPAnalyticsEvent {
		const tags = this.tags.concat(this.additionalTags);

		return {
			action: Actions.GENERAL,
			label: this.label,
			tags,
		};
	}
}
